'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const client = require('./client');

export default class EmbeddedDossier extends React.Component {
	
	constructor(props) {
		super(props);
	
		this.state = {
			dossierInstance:""
	    };
		
		this.changeFilter = this.changeFilter.bind(this);
		
	}
	
	changeFilter(filterSelection){
		



		var lSelection = {
				selections: [],

				  filterInfo: {
				    key: filterSelection.key,
				  }	
		};
		filterSelection.value.map(function(item){
			var lSelectionObj = {};
			lSelectionObj.name = item;
			lSelection.selections.push(lSelectionObj)
		})
		
		this.state.dossierInstance.filterSelectMultiAttributes(lSelection);
	}
	
	componentDidUpdate() {
		var app =  this;
		if(app.state.dossierInstance && app.state.dossierInstance != ""){
		   	if(app.props.showToolBar) {
				 app.state.dossierInstance.openFilterSummaryBar(); 
			} else{
				app.state.dossierInstance.closeFilterSummaryBar();
			}
		}
	}

	componentDidMount() {
		var app =  this,
			container = document.getElementById("mydossier"),
			//url ="http://www.xeomatrix.net:8080/MicroStrategyLibrary/app/8BD9132441AC652FB69CE2A949F7E89C/096A258948B072CD7DFBC79D60EF4533/K0805D53511E7F1869BC70080EFEEB180--K0805D1E311E7F1869BC70080EFEEB180";
			url ="http://application.cds.com:8080/MicroStrategyLibrary/app/B19DEDCC11D4E0EFC000EB9495D0F44F/D5C2D6A711E7B44200000080AF016FEC/K9EEC99D84E71D345ABBE048319803AE7--KFDF9DEEB458E128C2BEA84977D979157";
		var x = 0;
		var postData = {};
		
		function getXHRRequestPromise(url, body, method, contentType, desiredHeader) {
	        return new Promise(function(resolve, reject) {
	            var xhr = new XMLHttpRequest();
	            xhr.open(method, url);
	            xhr.setRequestHeader('Content-Type', 'application/json');
	            xhr.setRequestHeader("Accept", "application/json");
	           
	            xhr.onreadystatechange = function() {
	                if (xhr.readyState === 2) {
	                	var lResult = xhr.getResponseHeader(desiredHeader);
	                	console.log(lResult)
	                    resolve(lResult);
	                } else {
	                    reject({
	                        status: this.status,
	                        statusText: xhr.statusText
	                    });
	                }
	            };
	            xhr.send(JSON.stringify(body));
	        });
	    };
	    
		postData.username = 'administrator';
		postData.password = '';
		postData.loginMode = 1;
		x = x+1;
		

		//getXHRRequestPromise('http://example.cds.com:8080/mstrlogin', postData, 'POST', 'application/json', 'x-mstr-authToken');
		
		
        microstrategy.dossier.create({
            url: url,
            enableResponsive: true,
            enableCustomAuthentication: true,
            customAuthenticationType: microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN,
            placeholder: container,
            getLoginToken: function () {
                return getXHRRequestPromise('http://application.cds.com:8080/cdsportal/mstrlogin', postData, 'POST', 'application/json', 'x-mstr-authToken').then(function(authToken) {
                    return authToken;
                })
                //return getXHRRequestPromise('http://application.cds.com:8080/MicroStrategyLibrary/api/auth/login', postData, 'POST', 'application/json', 'x-mstr-authToken').then(function(authToken) {
                //    return authToken;
                //})
                //return getXHRRequestPromise('http://www.xeomatrix.net:8080/MicroStrategyLibrary/api/auth/login', postData, 'POST', 'application/json', 'x-mstr-authToken').then(function(authToken) {
                //    return authToken;
                //})
            }
         }).then(function (dossier) {
        	 if(app.props.showToolBar) {
        		 dossier.openFilterSummaryBar(); 
        	 } else{
        		 dossier.closeFilterSummaryBar();
        	 }
        	 //
        	 dossier.getFilterList().then(function(filters){
        		 var lFilters = filters;
        		 app.props.onDocumentLoad(lFilters);
        		 app.setState({dossierInstance: dossier});
        	 });
        	 
         });
		
        
	}
	
	render() {
		return(
				<div id="mydossier" />
		)
	}
}


// WEBPACK FOOTER //
// ./src/main/js/EmbeddedDossier.js